import { ContentAsset, Item, ItemSetting } from 'able-lib'
import { ITEM_LESSON_PLAN_TEMPLATE, ITEM_LESSON_TEMPLATE } from 'src/lib/tools/lesson'

export interface LessonControls {
  openNote: boolean;
  openChat: boolean;
}

export interface LessonPlanFilter{
  year: 2020;
  levelId: null;
  subjectId: null;
}

export interface LessonStateInterface {
  lesson: Item;
  lessonDraft: Item;
  lessonPlanList: Array<Item>;
  lessonPlanDraft: Item;
  inheritedActivities: Array<Item>;
  lessonPlanFilter: LessonPlanFilter;
  lessonplans: Array<Item>;
  lessonSettings: Array<ItemSetting>;
  lessonControls: LessonControls;
  library: {
    materials: Array<ContentAsset>;
  };
}

export default function (): LessonStateInterface {
  return {
    lesson: null,
    lessonDraft: ITEM_LESSON_TEMPLATE,
    lessonPlanList: [],
    lessonPlanDraft: ITEM_LESSON_PLAN_TEMPLATE,
    inheritedActivities: [],
    lessonPlanFilter: {
      year: 2020,
      levelId: null,
      subjectId: null
    },
    lessonplans: [],
    lessonSettings: [],
    lessonControls: {
      openNote: true,
      openChat: false
    },
    library: {
      materials: []
    }
  }
}
